import { createApp } from "vue";
import VueClickAway from "vue3-click-away";
import { animateComponents, animateHero } from "~/js/utils/animation.ts";

import Home from "~/vue/Home.vue";

// Main app
const home = async () => {
	const app = createApp(Home);

	app.use(VueClickAway);
	app.use(window.pinia);

	return app.mount("#home");
};

// Execute async function
home().then(() => {
	//animation
	animateHero();
	animateComponents();
});
